<template>
  <div>
    <div class="item-overlay">
      <was-watched :video="`${item.id}`"></was-watched>
      <div>
        <star-series :series="item"></star-series>
      </div>
    </div>

    <router-link :to="{ name: 'videoSeries', params: { sid: item.id } }"
      ><img :src="imgUrl" :alt="item.pagetitle" class="video-img" />
      <div class="play-icon">
        <img
          :src="
            this.$store.state.initialData.basepath +
            'assets/yoga/images/play-icon.png'
          "
        />
      </div>

      <div class="video-info">
        <div class="series-tag" v-if="item.parent !== '10'">
          <img src="@/assets/images/seriesResultTag.png" alt="" />
          <span>סדרה</span>
        </div>
        <div class="series-tag" v-else>
          <img src="@/assets/images/Imunim.png" alt="" />
          <span>תוכנית</span>
        </div>
        <div>
          <current-tag
            :current="getCurrent"
            :base="this.$store.state.initialData.basepath"
          >
          </current-tag>
        </div>
        <level-icon :level="level"></level-icon>
      </div>
      <h4 class="video-item-h4">{{ item.pagetitle }}</h4>
      <div>
        <teacher-tag
          :teacher="getTeacher"
          :base="this.$store.state.initialData.basepath"
        >
        </teacher-tag>
      </div>
      <p class="description" v-html="abstract"></p>
      <div class="read-more">
        <svg style="width: 20px; height: 20px;" viewBox="0 0 20 20">
          <path
            fill="currentColor"
            d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
          />
        </svg>
      </div>
    </router-link>
  </div>
</template>

<script>
import TeacherTag from "@/components/TeacherTag_v2.vue";
import CurrentTag from "@/components/CurrentTag_v2.vue";
import WasWatched from "@/components/video_page/WasWatched_v2.vue";
import LevelIcon from "@/components/levelIcon.vue";
import StarSeries from "@/components/series/StarSeries_v2.vue";

export default {
  name: `VideoItem`,

  props: {
    item: Object,
  },
  components: {
    CurrentTag,
    TeacherTag,
    WasWatched,
    LevelIcon,
    StarSeries,
  },

  computed: {
    imgUrl() {
      return this.$store.state.initialData.basepath + this.item.image;
    },
    getCurrent() {
      if (Array.isArray(this.$store.state.currents)) {
        const arr = this.$store.state.currents.filter(c => {
          if (
            typeof c.resource !== `undefined` &&
            c.resource.id === this.item.current
          ) {
            return true;
          }
          return false;
        });

        return arr[0];
      }
      return {};
    },
    getTeacher() {
      const arr = this.$store.state.initialData.teachers.filter(t => {
        if (t.id === this.item.teacher) {
          return true;
        }
        return false;
      });
      if (arr[0]) {
        return arr[0];
      }
      return { id: `` };
    },
    level() {
      if (this.$store.state.initialData.levels.length > 0) {
        const arr = this.$store.state.initialData.levels.filter(l => {
          if (l.value === this.item.level) {
            return true;
          }
          return false;
        });
        return arr[0];
      }
      return { label: `` };
    },
    abstract() {
      const str = this.item.description;
      if (str.length > 150) {
        return `${str.slice(0, 150)}...`;
      }
      return str;
    },
  },
};
</script>

<style lang="scss">
.series-tag {
  img {
    position: relative;
    top: 2px;
    margin-left: 2px;
    max-height: 18px;
    width:auto;
  }
}
</style>
